<template>
	<div
		class="flex min-h-[400px] w-full flex-col justify-between rounded bg-gradient-to-b from-[#01c2af] to-[#3175b6] px-6 py-12"
	>
		<div class="flex-1 space-y-6">
			<h3 class="text-2xl text-white">Have a car to sell?</h3>
			<p class="text-white">
				Have a safe and hassle-free experience, sell your car to us and
				receive a competitive trade-in price.
			</p>
			<SellMyCarModal :button-text="'Get an instant valuation'" />
		</div>
		<CarbarImage
			image="img/buy-car/img-buyused-cars.webp"
			alt-text="Buy Used cars"
		/>
	</div>
</template>

<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import SellMyCarModal from '@/components/sell-my-car/SellMyCarModal.vue'
</script>
